import React from 'react';
import MissionVisionHero from '../components/MissionVisionHero';
import MissionVisionStatements from '../components/MissionVisionStatements';
import StrategicObjectives from '../components/StrategicObjectives';
import JourneyCTA from '../components/JourneyCTA';

const MissionVision = () => {
  return (
    <div className="gfi-mission-vision-page-wrapper">
      
      {/* 1. INITIAL DUAL-TONE HERO INNER BANNER BLOCK */}
      <MissionVisionHero />
       <MissionVisionStatements />
        <StrategicObjectives />
         <JourneyCTA />
      
      {/* 2. Future Components (Mission/Vision Details, Objectives Grid) yahan aayenge */}

    </div>
  );
};

export default MissionVision;